import script from "./MediaDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaDetails.vue?vue&type=script&setup=true&lang=js"

import "./MediaDetails.vue?vue&type=style&index=0&id=77d8e5f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77d8e5f4"]])

export default __exports__